import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export const LOCATION_TABS = ["global", "local", "archived"] as const;
export type LocationTab = (typeof LOCATION_TABS)[number];

const LOCATION_TAB_PARAM = "locationTab";
const DEFAULT_LOCATION_TAB: LocationTab = "local";

const isLocationTab = (value: string | null): value is LocationTab =>
  value !== null && LOCATION_TABS.includes(value as LocationTab);

export const useDepotUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const rawTab = searchParams.get(LOCATION_TAB_PARAM);
  const locationTab = isLocationTab(rawTab) ? rawTab : DEFAULT_LOCATION_TAB;

  const setLocationTab = useCallback(
    (tab: LocationTab) => {
      setSearchParams((params) => {
        params.set(LOCATION_TAB_PARAM, tab);
        return params;
      });
    },
    [setSearchParams],
  );

  return { locationTab, setLocationTab };
};
